module.exports = __webpack_public_path__ + "img/archive.61c13f0a.svg";